import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './backFills';
import * as serviceWorker from './serviceWorker';

import {initStandAlone, testMccLogin} from "./harness/standAlone";
import App from './App';
import NavBar from "./harness/NavBar";

let _ = require('underscore');

let clientBridge = {connected:false};
const ClientBridge = React.createContext(clientBridge);
export {ClientBridge};


if (window.mcc) {
    window.reactLoader = reactLoader; // make available to MCC client
} else {

    const loginToMcc = async ()=>{
        await testMccLogin();
        loadClient();
    };

    const loadClient = ()=> {
        initStandAlone()
            .then(props => {
                //let callbacks;

                reactLoader('root', 'App', {
                    ...props,
                    setCallbacks: callbacks => {
                        //callbacks = appCallbacks
                        reactLoader('navBar', 'NavBar', {callbacks, ...props});
                    }
                });
                //reactLoader('navBar', 'NavBar', {callbacks, ...props});
            })
            .catch(err => {
                alert('AOD client start up failed: ' + err.message);
                console.error(err);
            });
    };

    reactLoader('navBar','NavBar', {callbacks:{loginToMcc}});
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

//##############################



// Exposed function to attach top level components as needed in the MCC cleint
function reactLoader(id, name, props, children) {

    // List of exposed components
    const lookup = {
        App,
        NavBar
    };

    clientBridge = {
        connected:true,
        ..._.pick(props,'mcc','wizard','mccLogin','model','aodService','active', 'publicRoot',
            'mccNav', 'mccAuth', 'setCallbacks')
    };

    const elem = React.createElement(lookup[name], props, children);
    ReactDOM.render(
        <ClientBridge.Provider value={clientBridge} children={elem}/>
        , document.getElementById(id));

    fixUnderscoreConflict();
    return elem;
}

function fixUnderscoreConflict(){
    if ('_' in window  && window._ && 'cloneDeep' in window._ ) {
        console.log('Lodash releasing window._ - reactLoader');
        window._.noConflict();
    }
    if (!('_' in window ) || !window._ || !('pluck' in window._) ) {
        console.log('No underscore at window._  - reactLoader');
    }
}